import { type BaseOptionType } from "antd/lib/select"

interface Attachment {
  id: string
  file: string
  original_filename: string
  file_size: number
  formatted_file_size: string
  mime_type: string
  created_by: string | null
  created_by_name: string | null
  created: string
  project: string | null
  model_type_display: string
  related_object_name: string | null
  folder?: string | null
  deleted_at?: string | null
  deleted_by_name?: string | null
  document_type?: string | null
  document_type_label?: string | null
  status?: string | null
  status_label?: string | null
  next_statuses?: string[]
  // Origin, not a document type or review status — read server-side off
  // who actually uploaded the row.
  customer_uploaded?: boolean
  // Additive, alongside the bare `project` id above — Global Files is the
  // first caller that needs to say which project a photo belongs to (and
  // its customer) without already knowing it from page context.
  project_info?: FileRecordInfo | null
  // `project_info` is a `SerializerMethodField` server-side, so its key is
  // always present even when Global Files never asked for it — this is the
  // explicit signal instead: `null` when not asked, `true`/`false` when it
  // was.
  is_company_scoped?: boolean | null
}

/** The project/lead a file belongs to, resolved server-side — Global Files'
 * "Related To"/"Customer" columns read this rather than a second fetch. */
interface FileRecordInfo {
  id: string
  uid: string
  name: string | null
  is_project: boolean
  customer_name: string | null
}

interface AttachmentFilterOptions {
  model_types: BaseOptionType[]
  file_types: BaseOptionType[]
  date_ranges: BaseOptionType[]
  milestones: BaseOptionType[]
  financial_items: BaseOptionType[]
  invoices: BaseOptionType[]
  checklist_items: BaseOptionType[]
  // The "Customer" filter's own searchable picker — scoped to customers
  // on a project the caller can see, narrowed to one project when
  // `project_id` was passed to `filter_options`. Absent for a
  // subcontractor caller (the origin filters this backs are a staff-only
  // surface).
  customers?: BaseOptionType[]
}

interface AttachmentUploadData {
  file: File
  project_id: string
  object_id: string
  model_type: AttachmentModels
  parent_type?: AttachmentParentModels
  folder?: string
}

enum AttachmentModels {
  CHECKLIST_ITEM = "checklist_item",
  MILESTONE = "milestone",
  INVOICE = "invoice",
  FINANCIAL_ITEM = "financial_item",
  PARTIAL_TRANSACTION_ITEM = "partial_transaction_item",
  PROJECT = "project"
}

enum AttachmentParentModels {
  MILESTONE = "milestone"
}

export type {
  Attachment,
  AttachmentFilterOptions,
  AttachmentUploadData,
  FileRecordInfo
}
export { AttachmentModels, AttachmentParentModels }
